import { configureStore, combineReducers, UnknownAction } from "@reduxjs/toolkit";
import authReducer from "src/features/authentication/hooks/userAuth";
import forgotPasswordReducer from "src/features/authentication/hooks/forgotPassword";
import resetPasswordReducer from "src/features/authentication/hooks/resetPassword";
import registerUserReducer from "src/features/authentication/hooks/registerUser";
import dealerDetailReducer from "src/features/dashboard/hooks/dealerDetail";
import dealersReducer from "src/features/admin/hooks/dealers";
import dealerReducer from "src/features/admin/hooks/dealer";
import addUpdateUserReducer from "src/features/userManagement/hooks/addUpdateUserResponsibility";
import userReducer from "src/features/userManagement/hooks/userResponsibility";
import endUserReducer from "src/features/dealers/hooks/endUser";
import endUsersReducer from "src/features/dealers/hooks/endUsers";
import endUsersForReportsReducers from "src/features/dealers/hooks/endUsersForReports";
import endUsersForDetailedReportsReducers from "src/features/dealers/hooks/endUsersForDetailedReports";
import endUserInstanceReducer from "src/features/endUser/hooks/endUserInstance";
import endUserInstancesReducer from "src/features/endUser/hooks/endUserInstances";
import endUserInstanceLocationReducer from "src/features/endUserInstance/hooks/endUserInstanceLocation";
import endUserInstanceLocationsReducer from "src/features/endUserInstance/hooks/endUserInstanceLocations";
import passwordProfilesReducer from "src/features/userManagement/hooks/passwordProfileResponsibility";
import ordersReducer from "src/features/orderManagement/hooks/orders";
import orderReducer from "src/features/orderManagement/hooks/order";
import exceptionEventsReducer from "src/features/dashboard/hooks/exceptionEvents";
import adapterUpdateReducer from "src/features/endUserInstance/hooks/adapterUpdate";
const combineReducer = combineReducers({
        auth: authReducer,
        forgotPassword: forgotPasswordReducer,
        resetPassword: resetPasswordReducer,
        registerUser: registerUserReducer,
        dealers: dealersReducer,
        dealer: dealerReducer,
        dealerDetail: dealerDetailReducer,
        users: userReducer,
        user: addUpdateUserReducer,
        passwordProfiles: passwordProfilesReducer,
        orders: ordersReducer,
        order: orderReducer,
        endUsers: endUsersReducer,
        endUserForReports: endUsersForReportsReducers,
        endUserForDetailedReports: endUsersForDetailedReportsReducers,
        endUser: endUserReducer,
        endUserInstance: endUserInstanceReducer,
        endUserInstances: endUserInstancesReducer,
        endUserInstanceLocation: endUserInstanceLocationReducer,
        endUserInstanceLocations: endUserInstanceLocationsReducer,
        exceptionEvents: exceptionEventsReducer,
        adapterUpdate: adapterUpdateReducer
});

const rootReducer = (state: any, action: UnknownAction) => {
        if (action.type == "RESET") {
                state = {};
        }
        return combineReducer(state, action);
}

export const store = configureStore({
        reducer: rootReducer
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
